// @flow
import {
  GET_MACHINES_SUCCESS,
} from './actionTypes';

const initialState = {

};

const Machines = (state = initialState, action) => {
  switch (action.type) {
    case GET_MACHINES_SUCCESS:
      return action.payload;

    default:
      return state;
  }
};

export default Machines;
